export const calculateSavingsPercentage = (weeklyPrice: number, yearlyPrice: number): number => {
  const weeklyAnnualized = weeklyPrice * 52;
  if (weeklyAnnualized <= 0) return 0;
  return Math.round(((weeklyAnnualized - yearlyPrice) / weeklyAnnualized) * 100);
};

/**
 * Currency code to symbol mapping for common currencies.
 * Used as a fallback when priceString parsing fails.
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  KRW: '₩',
  INR: '₹',
  BRL: 'R$',
  CAD: 'CA$',
  AUD: 'A$',
  HKD: 'HK$',
  SGD: 'S$',
  MXN: 'MX$',
  CHF: 'CHF',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  THB: '฿',
  TRY: '₺',
  RUB: '₽',
  ZAR: 'R',
  NZD: 'NZ$',
  TWD: 'NT$',
  MYR: 'RM',
  PHP: '₱',
  IDR: 'Rp',
  VND: '₫',
  ILS: '₪',
  AED: 'AED',
  SAR: 'SAR',
  CLP: 'CLP$',
  COP: 'COP$',
  PEN: 'S/',
  ARS: 'ARS$',
  EGP: 'E£',
  PKR: 'Rs',
  NGN: '₦',
  KES: 'KSh',
};

/**
 * Get currency symbol from a currency code.
 * Falls back to the currency code itself if not found.
 */
export const getCurrencySymbol = (currencyCode: string | undefined | null): string => {
  if (!currencyCode) return '$';
  return CURRENCY_SYMBOLS[currencyCode.toUpperCase()] || currencyCode;
};
